<template>
 <div>
   <el-dialog title="应用申请" :visible.sync="dialogFormVisible" @close="closeDialog" :close-on-click-modal="false">
    <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="120px" class="demo-dynamic" :rules="rules">
      <el-form-item prop="applyName" label="应用名称">
        <el-input v-model="dynamicValidateForm.applyName" placeholder="请输入应用名称" :readonly="true"></el-input>
      </el-form-item>
      <!-- <el-form-item prop="companyName" label="申请企业">
        <el-input v-model="dynamicValidateForm.companyName" readonly placeholder="请输入您要申请的企业名称"></el-input>
      </el-form-item>
      <el-form-item prop="applicant" label="申请人">
        <el-input v-model="dynamicValidateForm.applicant" readonly placeholder="请提供申请人的姓名"></el-input>
      </el-form-item>
      <el-form-item prop="phone" label="联系电话">
        <el-input v-model="dynamicValidateForm.phone" readonly placeholder="顾问将于1-2个工作日内给您致电"></el-input>
      </el-form-item> -->
      <el-form-item prop="purpose" label="申请目的">
        <el-input type="textarea" :rows="4" v-model="dynamicValidateForm.purpose" placeholder="请输入您出于何种目的申请该应用"></el-input>
      </el-form-item>
      <el-form-item>
        <div class="resetForm" @click="closeDialog">取消</div>
        <div class="submitForm" @click="submitForm('dynamicValidateForm')">立即体验</div>
      </el-form-item>
    </el-form>
    <img class="sc3" src="../assets/images/sc_3@2x.png">
  </el-dialog>
  <!--反馈弹窗-->
  <SmallDialog ref="smallDialog" tip="申请成功！" name="MyApp"></SmallDialog>
 </div>

</template>
<script>
 import SmallDialog from './smallDialog.vue'
 import {
    fetchApplicationApply,
    fetchUserData
  } from '@/api/api'
  export default {
    data() {
      return {
        dialogFormVisible: false,
        dynamicValidateForm: {
          purpose: '',
          // phone: '',
          // companyName: '',
          // applicant: '',
          applyName: ''
        },
        rules: {
          // applicant: [
          //    { required: true, message: '请输入申请人姓名', trigger: 'blur' }
          // ],
          // companyName: [
          //   { required: true, message: '请输入企业名称', trigger: 'blur' }
          // ],
          // phone: [
          //   { required: true, message: '请输入联系电话', trigger: 'blur' }
          // ],
          purpose:[
             { required: true, message: '请输入申请目的', trigger: 'blur' }
           ]
        },
        flag: '', // 2 表示控制台点的弹窗，不需要smallDialog
      };
    },
    components: {
      SmallDialog
    },
    watch: {
    },
    created() {
    },
    props: ['dialogData','id'],
    methods: {
      closeDialog() {
         this.dialogFormVisible= false
         this.resetForm('dynamicValidateForm')
      },
      openDialog(val,flag) {
        this.dynamicValidateForm.applyName = val
        this.dialogFormVisible= true
        this.flag = flag
        this.getUserData()
      },
      getUserData() {
        fetchUserData().then(res => {
          const {companyName, realname, nickName, phone} = res.data
          // this.dynamicValidateForm.companyName = companyName
          // this.dynamicValidateForm.applicant = realname
          // this.dynamicValidateForm.phone=phone
          if(!phone || !companyName || !realname) {
            this.$message.error('请先完善信息')
            this.goAddInfo()
          }
        })
      },
      goAddInfo() {
        this.$router.push({
          name: 'PersonalData'
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = {
              applicationId: this.id,
              ...this.dynamicValidateForm
            }
            fetchApplicationApply(params).then(res => {
              if(res.code === 0) {
                this.$message.error(res.msg)
              }else {
                if(this.flag && this.flag === 2) {
                  this.$message({
                    showClose: true,
                    message: '申请成功',
                    type: 'success'
                  });
                  this.closeDialog()
                }else{
                  this.$refs.smallDialog.openDialog()
                  this.closeDialog()                 
                }
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  }
</script>
<style scoped>
  /deep/ .el-dialog {
    width: 643px;
    height: 500px;
    background: #fff url('../assets/images/dialogBg@2x.png') top left no-repeat;
    background-size: 100%;
    padding-top: 30px;
    position: relative;
    border-radius: 15px;
    overflow: hidden;
  }

  .el-form-item {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  /deep/ .el-form-item__label {
    margin-left: 60px !important;
    width: 476px !important;
    text-align: left !important;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #0A0909;
  }

  /deep/ .el-form-item__content {
    margin-left: 60px !important;
    width: 476px !important;
  }

  .submitForm {
    width: 220px;
    height: 45px;
    background: #0F5EFF;
    border-radius: 23px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 22px;
    text-align: center;
    line-height: 45px;
    margin-top: 30px;
    cursor: pointer;
  }

  .resetForm {
    cursor: pointer;
    width: 220px;
    height: 45px;
    background: #E8EDF6;
    border-radius: 23px;
    ont-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #A7AFC3;
    line-height: 22px;
    text-align: center;
    line-height: 45px;
    margin-top: 30px;
  }

  /deep/ .el-dialog__body {
    padding: 15px 20px
  }

  /deep/ .el-form-item__content {
    display: flex;
    justify-content: space-between;
  }

  /deep/ .el-input__inner {
    height: 45px;
  }

  /deep/ .el-dialog__header {
    width: 476px;
    margin: 0 auto;
  }

  /deep/ .el-dialog__title {
    font-size: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #0A0909;
    line-height: 37px;
  }

  .sc3 {
    width: 100px;
    height: 48px;
    position: absolute;
    bottom: 70px;
  }
</style>



// WEBPACK FOOTER //
// src/components/marketDialog.vue